import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  alignContent: "center",
  justifyContent: "flex-left",
  gap: 32,
  paddingTop: 8,
  paddingBottom: 24,
}));

export const CardsWrapper = styled("div")(() => ({
  display: "flex",
  alignContent: "center",
  justifyContent: "flex-left",
  gap: 8,
}));

type CardProps = {
  color: string;
};
export const Card = styled("div")(({ color }: CardProps) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "10px 24px",
  gap: 4,
  backgroundColor: color,
  borderRadius: 4,
}));

export const CardTitle = styled("span")(({ color }: CardProps) => ({
  color,
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: 0.5,
}));

export const CardSubtitle = styled("span")(({ color }: CardProps) => ({
  color,
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.25,
}));
